"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialValue = exports.DialTrackerContainer = exports.DialMeter = exports.DialLabelAndDescription = exports.DialLabel = exports.DialDescription = void 0;
var _react = require("@linaria/react");
var _intents = _interopRequireDefault(require("@ux/intents"));
const intents = new _intents.default();
const DialTrackerContainer = exports.DialTrackerContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "DialTrackerContainer",
  class: "dm87l16"
});
const DialMeter = exports.DialMeter = /*#__PURE__*/(0, _react.styled)("div")({
  name: "DialMeter",
  class: "d41gb91"
});
const DialValue = exports.DialValue = /*#__PURE__*/(0, _react.styled)("div")({
  name: "DialValue",
  class: "dguqia1"
});
const DialLabel = exports.DialLabel = /*#__PURE__*/(0, _react.styled)("h3")({
  name: "DialLabel",
  class: "dwdjsw4"
});
const DialDescription = exports.DialDescription = /*#__PURE__*/(0, _react.styled)("p")({
  name: "DialDescription",
  class: "d155hy0y"
});
const DialLabelAndDescription = exports.DialLabelAndDescription = /*#__PURE__*/(0, _react.styled)("div")({
  name: "DialLabelAndDescription",
  class: "dvsjhgh"
});